(function ($) {
  pcgProductLargeV1 = {
    formatter: $('.pcg-product-large-v1')
  };

  Drupal.behaviors.pcgProductLargeV1 = {
    get: function (key) {
      return pcgProductLargeV1[key];
    },

    set: function (key, val) {
      pcgProductLargeV1[key] = val;
    },

    attach: function (context, settings) {
      var self = this;
      var formatter = self.get('formatter');

      formatter.each(function () {
        var thisFormatter = $(this);

        // if the badge label is empty remove the class that makes the colored circular badge	
        if (thisFormatter.find('.badge-inner').html() == '') {
          thisFormatter.find('.badge-inner').parents().removeClass('badge');
        }

        // quickview slide down
        thisFormatter.find('.btn-quickview').once('template-btn-quickview').on('click', function(e) {
          e.preventDefault();
          $('#quickshop .close').trigger('click');
          var prodId = $(this).closest('.mpp-box').attr('data-productid');

          if (typeof prodId !== 'undefined') {
            var product = page_data['product-input-type'].products.filter(function (p) {
              return p.PRODUCT_ID === prodId;
            })[0];
            var $qs = site.quickshop.render({
              productData: product
            });
            var clickedProduct = $(this).closest('.mpp-box');
            var bottom_padding = 50;
            var speed = 500;
            var topPositionNavOffset = $('#top').height() + 40;

            // append after row
            $qs.insertAfter($(this).parents('.row')).delay(100).slideDown(speed, function () {
              var pos = $qs.position();
              var window_height = $(window).height();
              var offset = $qs.offset();
              var posY = offset.top - $(window).scrollTop();
              var clickedProductOffset = clickedProduct.offset();
              var clickedProductY = clickedProductOffset.top - $(window).scrollTop();
              var qs_bottom_position = posY + $('#quickshop').height() + bottom_padding;

              // only scroll page if the quickshop fall within the viewable area
              if (qs_bottom_position > window_height) {
              /**
               * bottom of quickshop isn't visible, so let's formulate both options
              **/
                // option 1: place selected product near top of viewing area
                var prod_row = (clickedProductY - topPositionNavOffset) + $(window).scrollTop();
                // option 2: place quickshop within viewing area, sacrifice selected product in viewport if needed
                var quickshop_in_viewport = (qs_bottom_position - window_height) + $(window).scrollTop();
                // select our best option
                var scrollPosition = quickshop_in_viewport < prod_row ? prod_row : quickshop_in_viewport;

                // now scroll the window...
                $('body, html').scrollTo(scrollPosition, {
                  duration: speed,
                  axis: 'y'
                });
              }
            });
            // override close to remove dom node
            $qs.find('.close').off('click').on('click', function() {
              $qs.slideUp('500', function () {
                $qs.remove();
                $('div[data-productid="' + product.PRODUCT_ID + '"] .caret').addClass('hidden');
              });
            });
            // show caret
            $('div[data-productid="' + product.PRODUCT_ID + '"] .caret').removeClass('hidden');
          }
        });
      });
    }
  };

  $('.online-price').hover(function () {
    $(this).siblings('.online-price-hover-content').show();
  }, function () {
    var that = $(this).siblings('.online-price-hover-content');

    setTimeout(function () {
      if (!that.is(':hover')) {
        that.fadeOut(300);
      }
    }, 250);
  });
  $('.online-price-hover-content').mouseleave(function () {
    $(this).fadeOut(300);
  });
})(jQuery);
